import moment from 'moment';
import _ from 'lodash';

/**
 * Date format used to access events
 * @type {string}
 */
const DATE_FORMAT = 'YYYY-MM-DD';

class EventsController {

  constructor(EventsService, OfficesService, $window, $q, $state) {
    'ngInject';
    Object.assign(this, {EventsService, OfficesService, $state});
    this.events = {}; // empty object to avoid initial errors
    this.selectedDay = null;
    this.calendarOptions = {
      customClass: this.getDayClass.bind(this),
      minDate: new Date(),
      showWeeks: false
    };
    // since offices are used for visualization, resolve all promises at the same time
    let eventsPromise = EventsService.list(), officesPromise = OfficesService.list();
    // when both promises are resolved
    $q.all([eventsPromise, officesPromise]).then((results) => {
      let events = results[0], offices = results[1];
      console.debug('Offices and events retrieved');
      // assign offices
      this.offices = _.keyBy(offices, 'id');
      // group events by starting day, start_timestamp is a moment object
      this.events = _.groupBy(events, (e) => e.start_timestamp.format(DATE_FORMAT));
      // trigger the watcher after events are loaded to show events on calendar
      this.selectedDay = new Date();
    });
    // true iff on tablet
    this.bigScreen = $window.innerWidth >= 768;
    // past event filter
    this.showPastEvents = false;
  }

  /**
   * Used to customize class for day icons
   */
  getDayClass(data) {
    return this.hasEvents(data.date) ? 'full' : '';
  }

  /**
   * Return true if there are events for currently selected day
   * @param day to check as javascript Date object
   * @returns {boolean}
   */
  hasEvents(day) {
    return !_.isEmpty(this.events[moment(day).format(DATE_FORMAT)]);
  }

  /**
   * Return a list of offices with events for selected day
   * @param day
   * @returns {*} list of unique offices for selected day
   */
  getOfficesFor(day) {
    // involved offices for tablet lists
    return _(this.events[moment(day).format(DATE_FORMAT)]).map('id_sede').uniq().value();
  }

  /**
   * Return a sorted list of events for selected day
   * @param day
   * @param office_id
   * @returns {*}
   */
  getEventsFor(day, office_id) {
    return _(this.events[moment(day).format(DATE_FORMAT)]).filter({id_sede: office_id}).value();
  }

  /**
   * Select an event in the interface
   * @param event selected event
   */
  selectEvent(event) {
    this.$state.go('events.event', {officeId: event.id_sede, eventId: event.id_elemento});
  }

  togglePastEvents() {
    this.showPastEvents = !this.showPastEvents;
  }

  isDateShown(date) {
    return this.showPastEvents || moment(date, DATE_FORMAT).isAfter(moment().add(-1, 'days'));
  }

  officeName(id) {
    return _.has(this.offices, id) ? this.offices[id].label : '';
  }

  ifFullDay(event) {
    return event.start_timestamp.format('HH:mm:ss') == '00:00:00';
  }

  eventTime(event) {
    return `${event.start_timestamp.format('HH:mm')} ${moment(event.a, 'DD/MM/YYYY HH:mm').format('HH:mm')}`;
  }
}

export default EventsController;



// WEBPACK FOOTER //
// ./client/app/components/events/events.controller.js